export enum ContasReceberRefinamentoEnum {
    Cliente = 1,
    NumeroDocumento = 2,
    Historico = 3,
}
